import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { ITyped } from '../shared/interfaces/typed.interface';
import { ChartTypesEnum } from './chart-types.enum';
import { Dataset } from './sub-models/dataset.model';

export const SUMMARY_CHART_SCHEMA = Object.freeze({
  TYPE: '',
  GROUP: 0,
  DATASETS: List<Dataset>([]),
});
const RECORD = generateSchema(SUMMARY_CHART_SCHEMA);
const KEYS: any = generateKeys(SUMMARY_CHART_SCHEMA);

export class SummaryChart extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.DATASETS,
        value: props.get(KEYS.DATASETS)
          ? this.datasets.map((params) => new Dataset(params))
          : List<Dataset>([]),
      },
    ]);

    return selfModel as SummaryChart;
  }

  get type(): string {
    return ChartTypesEnum.summary_chart;
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }

  get datasets(): List<Dataset> {
    return this.get(KEYS.DATASETS);
  }
}
